export const headersTramitacao = [
  { text: '', width: 1, key: 'proaqTramitacaoOffcanvas' },
  { text: 'ID', width: 2, key: 'proaqTramitacao' },
  { text: 'Data Entrada', width: 10, key: 'proaqTramitacaoDateIn' },
  { text: 'Data Saída', width: 10, key: 'proaqTramitacaoDateOut' },
  { text: 'Unidade MS', width: 17, key: 'proaqTramitacaoUnidade' },
  { text: 'Usuário SEI', width: 20, key: 'proaqTramitacaoUsuario' },
  { text: 'Descrição', width: 40, key: 'proaqTramitacaoDescricao' },
];

export const valoresExibidosTramitacao: Record<string, string> = {
  id: 'ID',
  dataRegistro: 'Data de Registro',
  dataAtualizacao: 'Última Atualização',
  dataUltimaVisualizacao: 'Última Visualização',
  dataUltimaAtualizacao: 'Última Atualização',
  nEdicoes: 'Edições',
  nVisualizacoes: 'Visualizações',
  nVisualizadores: 'Visualizadores',
  usuarioRegistro: 'Responsável pelo Registro',
  usuarioAtualizacao: 'Responsável Ult. Atualização',
  usuarioUltimaVisualizacao: 'Responsável Ult. Visualização',
  observacoes: 'Observações',

  // Tramitação
  tramitacoes: 'Tramitações - SEI',
  entrada: 'Entrada - Última Tramitação',
  saida: 'Saída - Última Tramitação',
  usuarioSei: 'Usuário SEI - Última Tramitação',
  dataEntrada: 'Data de Entrada',
  dataSaida: 'Data de Saída',
  seiUsuario: 'Usuário SEI',
  seiDescricao: 'Descrição',
  seiUnidade: 'Unidade MS',
  descricao: 'Descrição - Última Tramitação',
  unidadeMS: 'Unidade MS - Última Tramitação',

  //Separadores
  separador: '',
  separadorLog: '',
  separadorTramitacao: '',
};

export const fieldObjectProaq = [
  'usuarioRegistro.nomeCompleto',
  'usuarioAtualizacao.nomeCompleto',
  'usuarioUltimaVisualizacao.nomeCompleto',
  'responsavel.nomeCompleto',
  'proaq.id',
  'proaqResponsavel.responsavel',
  'produtoDAF.produtoFarmaceutico',
  'denominacaoGenerica.denominacaoGenerica',
  'KitProdutoDAF.nomeKit',
];
